<template>
    <div>
        <AuthPopup
            v-if="showAuthPopup"
            :webview-redirect-to="createWebviewRedirectTo()"
            :show-close-button="false"
            @login-success="loginSuccess"
            @register-success="loginSuccess"
        />
    </div>
</template>

<script>
import UserService from '@/lib/user'
import AuthPopup from '@/components/AuthPopup'
import AuthPopupMixin from '@/mixins/auth-popup'
import popup from '@/lib/popup.js'
import Request from '@/lib/request.js'
import appConfig from '@/app.config.js'

export default {
    mixins: [AuthPopupMixin],

    components: {
        AuthPopup
    },

    data() {
        return {
            showAuthPopup: false
        }
    },

    mounted: function () {
        if (this.$router.currentRoute.name === 'set-share-skoler-quiz') {
            return this.$router.replace({
                name: 'login-skoler',
                query: {
                    id: this.$route.params.id,
                    token: this.$route.params.token,
                    share: true
                }
            })
        }

        const userService = new UserService()

        userService
            .validateToken()
            .then(() => {
                this.afterLoginSuccess()
            })
            .catch(() => {
                if (this.$router.currentRoute.name === 'set-share-skoler-quiz') {
                    return
                }

                this.showAuthPopup = true
            })
    },

    methods: {
        afterLoginSuccess() {
            const userService = new UserService()
            const request = new Request()
            const quizId = this.$route.params.id
            const token = this.$route.params.token
            const url = appConfig.api.setUserShareQuiz.replace('__id__', quizId).replace('__token__', token)
            let formData = {
                userId: userService.getUser().id,
                userEmail: userService.getUser().email
            }

            request
                .post(url, formData)
                .then(() => {
                    this.$router.replace({
                        name: 'my-quiz',
                        params: {
                            share: true
                        }
                    })
                })
                .catch(err => {
                    if (err.response.status) {
                        return popup.alert(err.response.data.message, () => {
                            window.location.href = '/'
                        })
                    }
                })
        }
    }
}
</script>
